'use es6';

import Banner from 'cookie-banner/banner';
import Context from 'cookie-banner/utils/context';
import Cookie from 'cookie-banner/utils/cookie';
import { HSPB_RAN, HSP_QUEUE_NAME } from 'cookie-banner/constants/hspb';
import { findAndRemoveFunctionCallFromQueue, logDebug, logError, searchCallAndRemoveFunctionsFromQueue } from 'cookie-banner/utils/hspbUtils';
const PRIVATE_BANNER_METHODS = {
  initialize: true,
  runCritsitCookieScrubbing: true,
  safeCallListener: true,
  setCookiePolicy: true,
  setPrivacyConsent: true,
  setPrivacySettings: true,
  cleanUpCookies: true,
  getVisitorCountry: true,
  sendReportingClickActivity: true,
  sendReportingViewActivity: true
};
export default class BannerRunner {
  constructor(context, cookie) {
    this.context = context || new Context();
    this.cookie = cookie || new Cookie(context);
    this.banner = new Banner(this.context, this.cookie);
  }
  setUpQueue(pushFn) {
    const win = this.context.getWindow();
    let hsp = win[HSP_QUEUE_NAME] = win[HSP_QUEUE_NAME] || [];
    if (!Array.isArray(hsp)) {
      hsp = win[HSP_QUEUE_NAME] = [];
    }
    hsp.push = pushFn;
  }
  processQueue(pushFn) {
    const hsp = this.context.getWindow()[HSP_QUEUE_NAME];

    // We want to make sure to configure the cookie of the banner first
    searchCallAndRemoveFunctionsFromQueue(hsp, ['setCookiesToSubdomain', 'setUseSecureCookies', 'addCookieDomain', 'addEnabledFeatureGates', 'setApiBaseUrl', 'setPortalId', 'setBusinessUnitId'], pushFn);
    const hasGeoTargetingCall = findAndRemoveFunctionCallFromQueue(hsp, 'getVisitorCountry');
    this.banner.initialize(hsp, hasGeoTargetingCall);
    while (hsp.length) {
      pushFn(hsp.shift());
    }
  }
  run() {
    const win = this.context.getWindow();
    if (win[HSPB_RAN]) {
      return;
    }
    logDebug('Initializing the banner runner...');
    const pushFn = args => {
      try {
        if (args && Array.isArray(args) && args.length > 0 && this.banner[args[0]]) {
          const methodName = args[0];
          const isFunction = this.banner[args[0]] instanceof Function;
          if (PRIVATE_BANNER_METHODS[methodName] || !isFunction) {
            return false;
          }
          const methodArguments = args.slice(1);
          return this.banner[methodName].apply(this.banner, methodArguments);
        }
      } catch (e) {
        logError(e);
      }
      return false;
    };
    this.setUpQueue(pushFn);
    this.processQueue(pushFn);
    win[HSPB_RAN] = true;
    logDebug('Done initializing the banner runner.');
  }
}